import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api/client';

export interface BillingPeriodRow {
  id: number;
  startDate: string;
  endDate?: string | null;
  package?: {
    id: number;
    hours: number;
    price: number;
    curency?: 'USD' | 'UZS';
  } | null;
}

/**
 * Every billing period of a contract, with each period's own package.
 *
 * Shared by the package-allowance card and the client-format header so both read
 * one cached response instead of issuing their own request.
 */
export function useBillingPeriods(contractId?: number, enabled = true) {
  return useQuery({
    queryKey: ['reportBillingPeriods', contractId],
    queryFn: async () => {
      const res = await api.get<{ results: BillingPeriodRow[] } | BillingPeriodRow[]>(
        '/billing-periods',
        { params: { contractId, limit: 200 } },
      );
      return Array.isArray(res) ? res : (res?.results ?? []);
    },
    enabled: enabled && !!contractId,
  });
}
